import DonutChart from '..';
import { useElementProps } from '../../../core/elements';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const DonutPatterns = () => {
  const {
    patternDefs
  } = useElementProps(DonutChart.elements.Theme);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: patternDefs
  });
};